<template>
    <div v-if="canUpdate">
        <settings-heading
            :title="$t('settings.custom_css.title')"
            :description="$t('settings.custom_css.description')"
            :button="$t('settings.save')"
            :button-disabled="!form.isDirty()"
            button-icon="add-circle"
            :button-loading="form.submitting"
            @button-click="submitForm"
        />

        <banner
            :description="$t('settings.custom_css.warning')"
            warning
            inline
        />

        <code-editor v-model="form.custom_css" autofocus class="mb-32" mode="css"></code-editor>

        <div class="flex justify-end mt-24 mb-48">
            <simple-button
                :disabled="!form.isDirty()"
                display="secondary"
                icon="save"
                :loading="form.submitting"
                look="primary"
                @click="submitForm"
            >
                {{ $t('settings.save') }}
            </simple-button>
        </div>

    </div>
    <error-403 v-else></error-403>
</template>

<script>
import SimpleButton from '../../components/ui/SimpleButton.vue';
import CodeEditor from '../../components/forms/CodeEditor.vue';
import Form from '../../etc/forms/Form';
import {mapState, mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import {useNotificationsStore} from '../../state/modules/notifications';
import * as jobsiteService from '../../services/JobsiteService';
import Jobsite from '../../models/Jobsite';
import {ADD_NOTIFICATION} from '../../state/mutation-types';
import {normalizeJson} from '../../../shared/helpers';
import confirmLeave from '../../mixins/confirmLeave';
import Error403 from '../../components/ui/Error403.vue';
import Banner from "../../components/ui/Banner.vue";
import SettingsHeading from "../../components/ui/SettingsHeading.vue";

// enable compat mode 3 VUE3_MIGRATION
CodeEditor.compatConfig = { MODE: 3 };

export default {
    components: {
        SettingsHeading,
        Banner,
        'simple-button': SimpleButton,
        'code-editor': CodeEditor,
        'error-403': Error403,
    },
    mixins: [
        confirmLeave,
    ],
    setup() {
        const mainStore = useMainStore();
        return {mainStore};
    },
    data: function () {
        return {
            form: this.generateForm(),
            canUpdate: this.$can('settings.jobsite'),
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        generateForm() {
            return new Form([
                {name: 'custom_css', value: this.mainStore.currentCompany.jobsite.custom_css},
            ]);
        },
        submitForm() {
            this.form.submit(data => {
                return jobsiteService.update(this.currentCompany.id, {
                    data: {attributes: data},
                });
            }).then(result => {
                return useRepo(Jobsite)
                    .whereId(result.id)
                    .update(normalizeJson(result));
            }).then(() => {
                this.form = this.generateForm();
                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: this.$t('settings.saved', {subject: this.$t('settings.custom_css.title')}),
                });
            });
        },
        refetchData() {
            jobsiteService.show(this.currentCompany.id).then(result => {
                return useRepo(Jobsite).save(normalizeJson(result.data));
            }).then(result => {
                if (this.form.isDifferent(result)) {
                    this.form = this.generateForm();
                }
            });
        },
    },
    created() {
        this.refetchData();
    },
};
</script>
